const STYLES = {
  green: "bg-emerald-100 text-emerald-700",
  amber: "bg-amber-100 text-amber-700",
  slate: "bg-slate-100 text-slate-700",
  blue: "bg-sky-100 text-sky-700",
  red: "bg-rose-100 text-rose-700",
};

export default function StatusBadge({ tone = "slate", children, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STYLES[tone]}`}
    >
      {children}
    </span>
  );
}

export function ActiveBadge({ active, testId }) {
  return active ? (
    <StatusBadge tone="green" testId={testId}>Active</StatusBadge>
  ) : (
    <StatusBadge tone="slate" testId={testId}>Inactive</StatusBadge>
  );
}
